export default "__VITE_ASSET__Dh8iCCgu__"